import React, { useState, useRef, useLayoutEffect, useEffect, forwardRef, createRef } from "react";

import { Link } from "react-router-dom"

import firebase from "../../utils/firebaseConfig"

import { 
  Badge,
  Button,
  ButtonGroup,
  Box,
  Card,
  Collapse,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  List,
  ListItem,
  ListItemIcon,
  MenuItem,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
  Paper,
} from "@mui/material";

import { styled } from '@mui/material/styles';


import { useSelector, useDispatch } from "react-redux";
import { editItem, fetchData } from "../../actions";

import { SnackbarProvider, useSnackbar } from 'notistack';

import MaterialTable from "material-table";

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import * as am4plugins_forceDirected from "@amcharts/amcharts4/plugins/forceDirected";
import { useLocation } from "react-router-dom";
import { v4 as uuid } from "uuid";

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

import tableIcons from "../tableFormatting/tableIcons";

import NanoCompModal from "../NanoCompModal";
import AssignmentsForm from "../AssignmentsForm";
import EditAssignments from "../AssignmentsForm/EditAssignments";
import NanoProgress from "../NanoProgress"

import SVGLogo from "../../images/Logo 2.png";
import DownloadPNG from "../../images/download.png";


import "./NanoVis.css";
import pdfLogo from "./pdfLogo";

// am4core.useTheme(am4themes_animated);

//

const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    border: `2px solid ${theme.palette.background.paper}`,
    padding: '0 4px',
    opacity: "0.6"
  },
}));



const NanoCompVisualiser = () => {
  const location = useLocation();
  const auth = useSelector(state => state.firebase);

  // const [newLocation, setNewLocation] = useState(location)
  const [pageData, setPageData] = useState(location.state);
  const [data, setData] = useState(pageData.data);

  const [updatedData, setUpdatedData] = useState(false);
  
  const [pilot, setPilot] = useState(false);


  // useEffect(() => {
  //   if(updatedData === true) {
  //   async function getdata() {
  //     const ref = firebase
  //         .firestore()
  //         .collection("nanoCompetencies");
  //       const snapshot = await ref.get();
  //       const fetchedData = []
  //       // const sortedData = []
  //       snapshot.forEach(doc => {
  //         fetchedData.push(doc.data());
          
          
  //       });
  //       setPageData(fetchedData[pageData.index])
  //       setData(fetchedData[pageData.index].data)

      
  //     // fetchedData.sort((a, b) => (a.index > b.index) ? 1 : -1)
  //     //   if(selectedDataSet == 1) {
  //     //     setData(fetchedData)
  //     //   }
  //     //   fetchedData.map((d,i) => {
  //     //     if(d.author == auth.auth.uid) {
  //     //       sortedData.push(d)
  //     //     }
  //     //   })
  //     //   if(selectedDataSet == 2){
  //     //     setData(sortedData)
  //     //   }

  //   }
  //     getdata()
  //   }
  //   // setIsLoading(true);

     

  //     setUpdatedData(false);

  // },[auth, updatedData])



  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [showProgress, setShowProgress] = useState(false);
  const [showEdit, setShowEdit] = useState(false);

  const [selectedDataSet, setSelectedDataSet] = useState(0);

  const [showDescription, setShowDescription] = useState(false);
  const [editAssignments, setEditAssignments] = useState(false);

  const [liked, setLiked] = useState(false);
  const [likedValue, setLikedValue] = useState(pageData.likes + 1);

  const updatedData2 = [];
  const dispatch = useDispatch();

  const [name, setName] = useState("");


  const [columns, setColumns] = useState([
    {
      title: "Subject",
      field: "name",
    },
    {
      title: "Relevance",
      field: "value",
    },

  ])

  const [subColumns, setSubColumns] = useState([
    {
      title: "Subject",
      field: "name",
    },
    {
      title: "Relevance",
      field: "value",
    },
    {
      title: "Relation",
      field: "strength",
    }
  ]);

  const [subColumns2, setSubColumns2] = useState([
    {
      title: "Subject",
      field: "name",
    },
    {
      title: "Relevance",
      field: "value",
    },
    {
      title: "Relation",
      field: "strength",
    }
  ]);

const [child, setChild] = useState([]);
const [childIndex, setChildIndex] = useState(0);
const [parentIndex, setParentIndex] = useState();
  const [childrenMap, setChildrenMap] = useState([]);
  const [childrenSort, setChildrenSort] = useState([]);
  const [childUpdate, setChildUpdate] = useState(false);
  const [data2, setData2] = useState([]);
  const [data3, setData3] = useState([]);

  const [firstIndex, setFirstIndex] = useState(0);
  const [refIndex, setRefIndex] = useState(0);

const [headers, setHeaders] = useState([]);
const [children, setChildren] = useState([]);

    
  const tableRef = useRef();

  // useEffect(() => {
  //   setUpdatedData(false);
  //   setData(pageData.data);
  // },[])

  useEffect(() => {
    if (liked == true) {
      setLikedValue(likedValue + 1);
    }
    if (liked == false) {
      setLikedValue(likedValue - 1);
    }
    // if (liked == false) {
    //   setLikedValue(likedValue - 1);
    // }


  }, [liked])



  useEffect(() => {
    
    if (selectedDataSet == 0) {
      setShowProgress(false);
      setShowEdit(false);
      setEditAssignments(false);
    }
    if (selectedDataSet == 1) {
      setShowProgress(false);
      setShowEdit(true);
      setEditAssignments(false);
    }
    if(selectedDataSet == 2) {
      setShowProgress(false);
      setShowEdit(false);
      setEditAssignments(true);
    }

    if (selectedDataSet == 3) {
      setShowProgress(true);
      setShowEdit(false);
      setEditAssignments(false);
    }

    if (selectedDataSet == 4) {
      setShowProgress(false);
      setShowEdit(false);
      setEditAssignments(false);
    }

  },[selectedDataSet])




useEffect(() => {

  data.map((d,i) => {

    // data.forEach((x,y) => {
      childrenSort.push({
        data: data[i].children
      })



      // headers.push((i ? ", " : "") + d.name)
      headers.push(" " + d.name)
      // d.children.map((x,y) => {
        // children.push([...d.children])
      // })
      // console.log(d)
    // })
    // x[y].children.map((d,i) => {
    //   console.log(d)
    // })
  // const removeLast = headers.slice((headers.length -1), 1)



  // setHeaders(removeLast)


  })
  // headers[headers.length - 1].slice(0, -2)
  setData2(data)


  
},[data, updatedData])
// console.log(children)
// useEffect(() => {
//   data.forEach((d,i) => {
        
//     headers.push(d.name + ", ")
//   })   
  
// }, [])
   // console.log(data)
       
        // console.log(data)

        const handlePilot = (event) => {
          setPilot(event.target.checked);
        };



  useLayoutEffect(() => {

    // headers[headers.length - 1].slice(0, -2)

    var chart = am4core.create("chartdiv", am4plugins_forceDirected.ForceDirectedTree);
    var networkSeries = chart.series.push(new am4plugins_forceDirected.ForceDirectedSeries());
    networkSeries.showOnInit = false;
    chart.legend = new am4charts.Legend();
    networkSeries.nodes.template.outerCircle.filters.push(new am4core.DropShadowFilter());
    networkSeries.nodes.template.togglable = false;
    networkSeries.maxLevels = 11;
    // networkSeries.nodes.template.expandAll = false;
    // networkSeries.dataFields.collapsed = "false";



    chart.data = data;
    

    networkSeries.dataFields.value = "value";
// console.log(chart.data)

    networkSeries.dataFields.name = "name";



    networkSeries.dataFields.strength = "strength";
    networkSeries.dataFields.children = "children";
    networkSeries.dataFields.description = "description";
    // networkSeries.nodes.template.tooltipText = "[text-align: center][bold]{name}[/]\nWeight: {value}\n\n [font-style: italic, font-size: 10px]Click to start assignment[/][/]";
    
networkSeries.tooltip.label.interactionsEnabled = true;
networkSeries.tooltip.pointerOrientation = "vertical";
    networkSeries.tooltip.label.interactionsEnabled = true;
    networkSeries.tooltip.keepTargetHover = true;
    // networkSeries.nodes.template.tooltipHTML = '{name}:{value}<b>{category}</b><br><button onClick={() => hello()}>More info</button>';
    // networkSeries.nodes.template.tooltipHTML = '<>console.log("dibudibu")</>';
    // networkSeries.tooltip.events.on('hit', console.log("diibudibu"));
   
    // networkSeries.colors.list = [
    //   // am4core.color("#F42B03"),
    //   // am4core.color("#D84A05"),
    //   // am4core.color("#EC7505"),
    //   // am4core.color("#E89005")
    // ];
// console.log(`${data[0].name.split(' ')[0][0]} ${data[0].name.split(' ')[1][0]}`)
    networkSeries.dataFields.color = "color";
    
    chart.exporting.menu = new am4core.ExportMenu();
    // chart.exporting.menu.container = document.getElementById("tools");
    chart.exporting.menu.align = "left";
    // chart.exporting.menu.items = [{
    //   "label": "...",
    // }];

    // chart.exporting.menu.items[0].icon = DownloadPNG;

// console.log(chart.exporting.menu.items)
// console.log(headers[headers.length - 1].slice(0, -2))
    chart.exporting.adapter.add("pdfmakeDocument", function(pdf, target) {
      
      pdf.doc.content.unshift({
        alignment: 'justify',
    columns: [{
        image: pdfLogo,
        fit: [119, 54]
    },{
      text: pageData.name,
    }],
    columnGap: 20,
    // pageBreak: "after",

    // margin: [0,30],
    style: {
      fontSize: 25,
      bold: true,
    }
    
      });
    return pdf;
  });

// forces page break after chart

  chart.exporting.adapter.add("pdfmakeDocument", function(pdf, target) {
    pdf.doc.content.push({
      alignment: 'justify',
pageBreak: "after",
   
columns: [

  {
    text: " ",
  },


],
columnGap: 20,
margin: [0, 5],
style: {
  fontSize: 16,
  bold: true,
}
});
return pdf;
});


  data.map((d,i) => {
    chart.exporting.adapter.add("pdfmakeDocument", function(pdf, target) {
      pdf.doc.content.push({
        alignment: 'justify',
    
        columns: [

          {
            text: d.name,
          },

     
        ],
        columnGap: 20,
        margin: [0, 30, 5, 5],
        style: {
          fontSize: 16,
          bold: true,
        }
      });
      return pdf;
    });

    
if(d.children) {
  d.children.map((d,i) => {
    chart.exporting.adapter.add("pdfmakeDocument", function(pdf, target) {
      pdf.doc.content.push({
        alignment: 'justify',
        // text: "Child nodes:",
    
        columns: [
          // {
          //   text: " ",
          // },

          {
            text: d.name,
          },
          // {
          //   text: " ",
          // },
     
        ],
        columnGap: 20,
        margin: [0, 10],
        style: {
          fontSize: 14,
          bold: true,
        }
      });
      return pdf;
    });

if(d.children) {

    d.children.map((d,i) => {
      children.push(d.name)
      chart.exporting.adapter.add("pdfmakeDocument", function(pdf, target) {
        pdf.doc.content.push({
          alignment: 'justify',
                    // margin: [0, 30],

      
          columns: [
            // {
            //   text: " ",
            // },          
            // {
            //   text: " ",
            // },
            {
              // text: (i ? ", " : "") + d.name,
              text: d.name,
            },
       
          ],
          columnGap: 20,
          // margin: [0, 30]
        });
        return pdf;
      });
    })
  }
  })
}
  
  })
// console.log(children)
    // remove url from pdf
    chart.exporting.getFormatOptions("pdf").addURL = false;




    // chart.exporting.menu.items[0].icon = downloadIcon;

    // var myEvent = networkSeries.tooltip.events.on("hit", function(ev, d) {
  networkSeries.nodes.template.events.on("hit", function(ev, d) {
        // console.log("clicked on ", ev.target.dataItem.dataContext.name);
        setName(ev.target.dataItem.dataContext.name)
        // console.log(ev)
       }, this);
       
      //  myEvent.dispose();
      // networkSeries.nodes.template.tooltipHTML = `<center><strong>{name}</strong>
      // <hr />
      // <table>
      // <input type="button" style="background-color: #fff" class="MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeMedium MuiButton-textSizeMedium MuiButtonBase-root  css-19dld3w-MuiButtonBase-root-MuiButton-root" value="Start {name} assignments"/>

      // </center>`;

      networkSeries.tooltip.label.wrap = true;

      // optional
      networkSeries.tooltip.label.maxWidth = 300;

      networkSeries.nodes.template.tooltipHTML = `<center><strong>{name}</strong>
      <hr />
      {description}

      </center>`;



    networkSeries.nodes.template.fillOpacity = 1;

  //   <tr>
  //   <th><center>Weight: </center></th>
  //   <td><center>{value}</center></td>
  // </tr>
    
    // networkSeries.nodes.template.label.text = "{name}"
    // networkSeries.nodes.template.label.text = function(name) {
    //   return `${name.split(' ')[0][0]} ${name.split(' ')[1][0]}` }
// console.log(`${data[0].name.split(' ')[0][0]} ${data[0].name.split(' ')[1][0]}`)
    // networkSeries.maxRadius = am4core.percent(6);
    // networkSeries.manyBodyStrength = -16;
    // networkSeries.nodes.template.label.hideOversized = false;
    networkSeries.fontSize = 14;
    

    networkSeries.nodes.template.label.text = "{name}";

// console.log(showProgress)

    if(showProgress == true) {
      networkSeries.nodes.template.adapter.add("stroke", function (fill, target) {
        return "green";
    });
    networkSeries.nodes.template.strokeWidth = "5%";
    networkSeries.nodes.template.strokeOpacity = 0.5;
    }
    
    // let circle = networkSeries.nodes.template.createChild(am4core.Circle);
    // circle.width = "{value}";
    // // circle.height = 12;
    // // circle.marginTop = 7;
    // circle.fill = "#000";
    // circle.fillOpacity = 0.6;

    // networkSeries.nodes.template.label.html = `<div style="padding: 20px"><div style="position: absolute; left: 50%; top: 0px; color:blue">&#9632;</div>{name}</div>`;
    networkSeries.nodes.template.label.truncate = true;

    networkSeries.nodes.template.label.horizontalCenter = "middle";
    networkSeries.nodes.template.label.verticalCenter = "middle";
    // networkSeries.nodes.template.label.fontSize = 30;

    




    networkSeries.links.template.propertyFields.strokeWidth = "strength";
    networkSeries.dataFields.centerStrength = "strength";

    
    var hoverState = networkSeries.links.template.states.create("hover");
    hoverState.propertyFields.strokeWidth = "strength";
    hoverState.properties.strokeOpacity = 1;
    
    networkSeries.nodes.template.events.on("over", function(event) {
      event.target.dataItem.childLinks.each(function(link) {
        link.isHover = true;
      })
      if (event.target.dataItem.parentLink) {
        event.target.dataItem.parentLink.isHover = true;
      }
    
    })
    networkSeries.dragFixedNodes = true;
        networkSeries.nodes.template.events.on("dragstop", function(event) {
        event.target.dataItem.fixed = true;  
    })
    
    networkSeries.nodes.template.events.on("out", function(event) {
      event.target.dataItem.childLinks.each(function(link) {
        link.isHover = false;
      })
      if (event.target.dataItem.parentLink) {
        event.target.dataItem.parentLink.isHover = false;
      }
    })
    
    
    // networkSeries.nodes.template.togglable = false;
    chart.zoomable = true;
    // chart.zoomDuration = 600;
    // networkSeries.nodes.template.events.on("hit", function(event) {
    //   if (event.target.isActive) {
    //     chart.zoomToDataItem(event.target.dataItem, 2, true)
    //   }
    //   else {
    //     chart.zoomOut();
    //   }
    // });

    // var zoomInButton = buttonContainer.createChild(am4core.Button);
    //     zoomInButton.label.text = "+";
    //     zoomInButton.events.on("hit", function(ev) {
    // var diff = dateAxis.maxZoomed - dateAxis.minZoomed;
    // var delta = diff * 0.2;
    //     dateAxis.zoomToDates(new Date(dateAxis.minZoomed + delta), new Date(dateAxis.maxZoomed - delta));
    // });

    // var zoomOutButton = buttonContainer.createChild(am4core.Button);
    //     zoomOutButton.label.text = "-";
    //     zoomOutButton.events.on("hit", function(ev) {
    // var diff = dateAxis.maxZoomed - dateAxis.minZoomed;
    // var delta = diff * 0.2;
    //     dateAxis.zoomToDates(new Date(dateAxis.minZoomed - delta), new Date(dateAxis.maxZoomed + delta));
    // });
    setChildUpdate(false)
// console.log(children)
    chart.current = chart;
    return () => {
      chart.dispose();
    };
  }, [data, childUpdate, showProgress]);


  const sendValues = () => {


    updatedData2.push({  
      index: pageData.index,
      author: pageData.author,
      data: data.map((d, i) => {
        // console.log(d)
        return {
          index: d.index,
          name: d.name,
          parentIndex: d.parentIndex,
          masterIndex: d.masterIndex,
          strength: d.strength,
          value: d.value,
          children: d.children.map((x,y) => {
            return {
              index: x.index,
              name: x.name,
              parentIndex: x.parentIndex,
              masterIndex: x.masterIndex,
              strength: x.strength,
              value: x.value,
              children: x.children.map((a,b) => {
                return {
                  index: a.index,
                  name: a.name,
                  parentIndex: a.parentIndex,
                  masterIndex: a.masterIndex,
                  strength: a.strength,
                  value: a.value,
                }
              

              })
            }
     
          })
        }
      }),
      likes: pageData.likes,
      name: pageData.name,
      description: pageData.description,
      isExample: pageData.isExample,
    })
    // setUpdatedData({
    //   index: pageData.index,
    //   author: pageData.author,
    //   likes: pageData.likes,
    //   name: pageData.name,
    //   description: pageData.description,
    //   isExample: pageData.isExample,
    //   data: data,

    // })
    console.log(updatedData2);
    dispatch(editItem(updatedData2[0]));
    setUpdatedData(true);
    enqueueSnackbar(pageData.name + " successfully updated!", { variant: "success" })


  }

function materialTable() {
  return (
    <Grid
    container
    spacing={0}
    direction="column"
    alignItems="center"
    justify="center"
    // style={{ minHeight: '100vh' }}
    >

{pageData.author == auth.auth.uid && pilot != true ? (
  <>
                    <ButtonGroup disableElevation variant="" color="primary" style={{ margin: "30px 0 20px 0" }}>
                      {/* <Button variant={selectedDataSet === 1 ? "contained" : "outlined"} onClick={()=>setSelectedDataSet(selectedDataSet === 1 ? 1 : 0)}>Edit Study Map</Button> */}
                      <Button variant={selectedDataSet === 1 ? "contained" : "outlined"} onClick={()=>setSelectedDataSet(1)}>Edit Study Map</Button>
                      <Button variant={selectedDataSet === 2 ? "contained" : "outlined"} onClick={()=>setSelectedDataSet(2)}>Edit Study Content</Button>
                      <Button variant={selectedDataSet === 3 ? "contained" : "outlined"}  onClick={()=>setSelectedDataSet(3)}>Show Study Progress</Button>
                      <Button variant={selectedDataSet === 4 ? "contained" : "outlined"}  onClick={()=>setSelectedDataSet(4)}>Mark Assignments</Button>
                    </ButtonGroup>

                  {editAssignments == true && (
                    <EditAssignments dataFeed={pageData} data={pageData.data} name={name} />
                  )}


                  {showProgress == true && (
                    <NanoProgress data={data} />
                  )}

                  {showEdit == true && (

<>                  
<MaterialTable
                  style={{ width: "90vw", margin: "20px 0 20px 0" }}
                  tableRef={tableRef}
                    data={data}
                    columns={columns}
                    icons={tableIcons}
                    title={pageData.name}
                    editable={{
                      onRowAdd: newData =>
                        new Promise((resolve, reject) => {
                          setTimeout(() => {
                             
                            
                            const newRow = {
                              name: newData.name,
                              value: newData.value,
                              strength: 0,
                              index: data.length,
                              masterIndex: data.length,
                              parentIndex: data.length,
                              uid: uuid(),
                              children: [],

                            }
                            // console.log(newRow)
                            // data.push(newRow)
                            setData([...data, newRow]);
                            console.log([...data, newRow])
                            // console.log(newData.push({fjnf: "ffff"}))
                            
                            resolve();
                          }, 0)
                        }),
                      onRowUpdate: (newData, oldData) =>
                        new Promise((resolve, reject) => {
                          setTimeout(() => {
                            const dataUpdate = [...data];
                            const index = oldData.tableData.id;
                            dataUpdate[index] = newData;
                            setData([...dataUpdate]);

                            // updateValues();
                            resolve();
                          }, 0)
                        }),
                      onRowDelete: oldData =>
                        new Promise((resolve, reject) => {
                          setTimeout(() => {
                            const dataDelete = [...data];
                            const index = oldData.tableData.id;
                            dataDelete.splice(index, 1);
                            setData([...dataDelete]);
                            
                            resolve()
                          }, 0)
                        }),
                    }}

                   
                    detailPanel=
                    {data2 =>  {
                      return (   
                        <div
                          ref={tableRef}
                          style={{ border: "1px solid blue", margin: "10px" }}>
                          <MaterialTable
                            data={data2.children}
                            columns={subColumns}
                            icons={tableIcons}
                    title={" "}

                            searchable={true}
                            // onClick={() => alert("clicked")}
                            editable={{

                              onRowDelete: oldData =>
                                new Promise((resolve, reject) => {
                                  setTimeout(() => {

                                    const dataDelete = [...data2.children];
                                    const index = oldData.tableData.id;
                                    const index2 = dataDelete[0].masterIndex;
                                    dataDelete.splice(index, 1)

                                    data.map(obj => {
                                      if(obj.index == data[index2].index) {
                                   
                                        obj.children = [...dataDelete]
                                      }
                                      return obj.children  
                                    })

                                    setChildUpdate(true)
                                    resolve()
                                  }, 1000)
                                }),
                              onRowAdd: (newData, oldData) =>
                              new Promise((resolve, reject) => {
                                setTimeout(() => {
                                  console.log(data2)
                                  const dataUpdated = [...data2.children];
                        
                                  
                                  dataUpdated.push({
                                    masterIndex: data2.index,
                                    parentIndex: data2.index,
                                    index: dataUpdated.length,
                                    name: newData.name, 
                                    value: newData.value, 
                                    strength: newData.strength,
                                    uid: uuid(),
                                    children: []
                                  })

// TODO : Make sure the row will add if user deletes all rows



                                  data.map(obj => {
                                    if(obj.index == data[dataUpdated[0].masterIndex].index) {
                              
                                      obj.children = [...dataUpdated]
                                    }

                                  return obj.children
                                  })

                                  setChildUpdate(true)
                                  resolve();
                                }, 1000)
                              }),
                              onRowUpdate: (newData, oldData) =>
                                new Promise((resolve, reject) => {
                                  setTimeout(() => {
                                    const dataUpdated = [...data2.children];
                            
                                    const index = oldData.tableData.id;
                                    dataUpdated[index] = newData;

                                    const updateState = () => {
                                      const newState = data.map(obj => {
                                        if (obj.index == oldData.masterIndex) {
                                          data[oldData.masterIndex].children = [...dataUpdated]
                                        }
                                    return  data[oldData.masterIndex].children
                                      })
                                    }

                                    setChildUpdate(true)
                                    updateState()
                                    resolve();
                                  }, 1000)
                                  
                                })
                                
                            }}
                           

                            options={{
                              search: false,
                              paging: false,
                              toolbar: true,
                              actionsColumnIndex: -1,
                              headerStyle: {
                                backgroundColor: "#f7f7f7",
                                position: "sticky",
                                top: 0
                              }
                            }}
                     
                      detailPanel=
                    {data2 => {
                      return (

            
                        <div
                          ref={tableRef}
                          style={{ border: "1px solid blue", margin: "10px" }}>
                          <MaterialTable
                            data={data2.children}
                            columns={subColumns2}
                            icons={tableIcons}
                    title={" "}

                            editable={{
                              onRowDelete: (oldData, newData) =>
                                new Promise((resolve, reject) => {
                                  setTimeout(() => {

                                    const dataUpdated = [...data2.children];
                              
                                    const index = oldData.tableData.id;
                                    dataUpdated[index] = newData;
                                    dataUpdated.splice(index, 1)

                                    const updateState = () => {
                                      const newState = data.map((obj, i) => {
                                        obj.children.map((d, y) => {
                               
                                          if(data2.index == data[data2.masterIndex].children[data2.index].index) {
                                      
                                           
                                            data[data2.masterIndex].children[data2.index].children = [...dataUpdated]
                                          }
                                        return data[data2.masterIndex].children[data2.index].children
                                        })
                                      })
                                    }

                                    setChildUpdate(true)
                                    // setData(data)
                                    updateState()

                                    resolve()
                                  }, 1000)
                                }),
                              onRowAdd: (newData, oldData) =>
                              new Promise((resolve, reject) => {
                                setTimeout(() => {
                                  

                                  const dataUpdated = [...data2.children];
                                  console.log(dataUpdated)
                                  dataUpdated.push({
                                    masterIndex: data2.masterIndex,
                                    parentIndex: data2.index,
                                    index: dataUpdated.length,
                                    name: newData.name, 
                                    value: newData.value, 
                                    strength: newData.strength,
                                    uid: uuid(),
                                  })
                                  // console.log(data[0].masterIndex)

                                  data.map(obj => {
                                    obj.children.map((d, y) => {
                                      if(dataUpdated[0].parentIndex == data[dataUpdated[0].masterIndex].children[dataUpdated[0].parentIndex].index) {
                                        
                                        return data[dataUpdated[0].masterIndex].children[dataUpdated[0].parentIndex].children = [...dataUpdated]
                                      }
                                    return data[dataUpdated[0].masterIndex].children[dataUpdated[0].parentIndex].children
                                  })
                                  })


                                //   data.map(obj => {
                                //     // console.log(data2.parentIndex)
                                //     // console.log(data[data2.masterIndex].children[data2.parentIndex].index)
                                //     // console.log(data[dataUpdated[0].masterIndex].children[dataUpdated[0].index].index)
                                //     // console.log(data[dataUpdated[0].masterIndex].children[dataUpdated[0].index].index == dataUpdated.index)
                                //     // console.log(dataUpdated.index)
                              
                                //   obj.children.map((d, y) => {
                                //     console.log(data[dataUpdated[0].masterIndex].children[dataUpdated[0].index])
                                //     console.log(obj.index + " = obj index")
                                //     console.log(dataUpdated[0].index + " = dataupdated")

                                //     if(dataUpdated[0].index == obj.index) {
                                //       console.log("yup")
                                //       return data[dataUpdated[0].masterIndex].children[dataUpdated[0].index] = [...dataUpdated]
                                //     }
                                //   return data[dataUpdated[0].masterIndex].children[dataUpdated[0].index]

                                // })
                                // })


                                  setChildUpdate(true)

                                  resolve();
                                }, 1000)
                              }),
                              onRowUpdate: (newData, oldData) =>
                                new Promise((resolve, reject) => {
                                  setTimeout(() => {
                                    const dataUpdated = [...data2.children];
                                    const index = oldData.tableData.id;
                                    dataUpdated[index] = newData;

                                    const updateState = () => {
                                      const newState = data.map((obj, i) => {
                                        obj.children.map((d, y) => {
                                          if(dataUpdated[0].parentIndex == data[dataUpdated[0].masterIndex].children[dataUpdated[0].parentIndex].index) {
                                           
                                            return data[dataUpdated[0].masterIndex].children[dataUpdated[0].parentIndex].children = [...dataUpdated]
                                          }
                                        return data[dataUpdated[0].masterIndex].children[dataUpdated[0].parentIndex].children
                                        })
                                      })
                                    }

                                    setChildUpdate(true)
                                    updateState()
                                    resolve();
                                  }, 1000)
                                })
                            }}
                           

                            options={{
                              search: false,
                              paging: false,
                              toolbar: true,
                              actionsColumnIndex: -1,
                              headerStyle: {
                                backgroundColor: "#f7f7f7",
                                position: "sticky",
                                top: 0
                              }
                            }}
                      

                            />
                            </div>
                          );
                        }}

                            />
                            </div>
                          );
                        }}
                        
                        options={{
                          search: false,
                          paging: false,
                          toolbar: true,
                          actionsColumnIndex: -1,
                          headerStyle: {
                            backgroundColor: "#f7f7f7",
                            position: "sticky",
                            top: 0
                          }
                        }}
                      
                      >



                      </MaterialTable>
<Button onClick={() => sendValues()}>Publish changes</Button>
</>
                      )}

</>
) : pilot == true && pageData.author == auth.auth.uid ? (
                        <AssignmentsForm name={name} />
) : (
                        <AssignmentsForm name={name} />

)}

</Grid>


  )
}

const finalSpaceCharacters = [
  {
    id: 'chartdiv',
    name: 'chartdiv',
  },
  {
    id: 'materialTable',
    name: 'materialTable',
  },
]

const [characters, updateCharacters] = useState(finalSpaceCharacters);

  function handleOnDragEnd(result) {

    if (!result.destination) return;

    const items = Array.from(characters);
    const [reorderedItem] = items.splice(result.source.index, 1);

    items.splice(result.destination.index, 0, reorderedItem);


    updateCharacters(items);

  }

function layoutConfig1() {

  if (characters[0].id === "chartdiv") {
  return (
    <div>
                  {/* <div id="tools" /> */}

              <div className="chartdiv" id="chartdiv" style={{ width: "90vw", height: "60vh", pageBreakAfter: "always" }}  />


    </div>
  )}  

  if (characters[0].id === "materialTable") {
  return (
    <div>
      {materialTable()}
    </div>
  )}  
}

function layoutConfig2() {

  if (characters[1].id === "chartdiv") {
    return (
      <div>
        <div className="chartdiv" id="chartdiv" style={{ width: "90vw", height: "60vh", pageBreakAfter: "always" }}  />
      </div>
    )}  

  if (characters[1].id === "materialTable") {
  return (
    <div>
      {materialTable()}
      
    </div>
  )}  
}


    return (
        <div>
          {pageData ? (
            <div>
              {pageData.author == auth.auth.uid && (
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                  justifyContent: "right",
                  margin: "20px 50px 0 0"                      
                }}>
                  <p>Pilot Content</p>
                  <Switch
                    checked={pilot}
                    onChange={handlePilot}
                    inputProps={{ 'aria-label': 'controlled' }}
                  />
              </div>
              )}

              <Grid>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                  justifyContent: "center"
                }}>


  
                <IconButton
                  style={{ position: "absolute", left: "5vw", marginTop: "20px" }}
                  
                  >
                    <Link 
                  to="/nanocompetencies" > 
                    <tableIcons.PreviousPage color="primary"  />
                    </Link>
                    
                    </IconButton>
                  <h1 className="pageHeader1" style={{ textAlign: "center", maxWidth: "75%" }}>{pageData.name}</h1>
                  
              
                
                  
                <IconButton
                  style={{ position: "absolute", right: "5vw", marginTop: "20px" }}
                  onClick={() => setLiked(liked === false ? true : false)} 
                  
                  >
                      <StyledBadge color={liked === false ? "primary" : "success"} anchorOrigin={{ vertical: "top", horizontal: "left" }} badgeContent={likedValue}>
                    <tableIcons.ThumbUpIcon color={liked === false ? "primary" : "success"}/>
                       </StyledBadge>
                  </IconButton>
              </div>
              </Grid>

                <Grid
                  container
                  spacing={0}
                  direction="column"
                  alignItems="center"
                  justify="center"
                  style={{ minHeight: '100vh' }}
                  >
                  {/* Chart */}
               
                  {showDescription == true ? (
                    <>
                      <IconButton onClick={() => setShowDescription(false)}><tableIcons.Close color="primary" /></IconButton>
                      <p className="description">{pageData.description}</p>
                      
                    </>

                  ):(
                    <Button onClick={() => setShowDescription(true)} startIcon={<tableIcons.InfoIcon color="primary" />}> Description</Button>

                  )}

<DragDropContext onDragEnd={handleOnDragEnd}>
          <Droppable droppableId="characters">
            {(provided) => (
              // <ul className="characters" {...provided.droppableProps} ref={provided.innerRef}>

              <List className="characters" {...provided.droppableProps} ref={provided.innerRef}>
                  
               
               
                    <Draggable key={characters[0].id} draggableId={characters[0].id} index={0}>
                      {(provided) => (
                        // <li className="drag-li" ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                      
                        <ListItem sx = {{
                          display: 'list-item'
                         }} className="drag-li" ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                           <ListItemIcon sx = {{
                          display: 'list-item',
                          textAlign: "center"
                         }}><Tooltip title="Move section"><tableIcons.DragHandleIcon /></Tooltip></ListItemIcon>
      <div>{layoutConfig1()}</div> 
                        </ListItem>
                       
                      )}
                    </Draggable>
                    <Draggable key={characters[1].id} draggableId={characters[1].id} index={1}>
                      {(provided) => (
                         
                        <ListItem sx = {{
                          display: 'list-item',
                          
                         }} className="drag-li" ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                            <ListItemIcon sx = {{
                          display: 'list-item',
                          textAlign: "center"
                         }}>
                           <Tooltip title="Move section"><tableIcons.DragHandleIcon /></Tooltip></ListItemIcon>
                          <div>{layoutConfig2()}</div>                         
                        
                        </ListItem>
                       
                      )}
                    </Draggable>
                   
                  {provided.placeholder}
                </List>
              )}
            </Droppable>
          </DragDropContext>
                </Grid>
            </div>
            ):(
                <div>
                Error please load page again
                </div>
            )}

        </div>
        );
    };
    
export default NanoCompVisualiser;